import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { TASK_TYPE_TRANSLATIONS } from '@bringg-frontend/global-stores';
import { TaskGroupTypes } from '@bringg/dashboard-sdk/dist/Task/Tasks.consts';
import { ResponseItem } from '@bringg/types';
import i18next from 'i18next';
import { getRoot } from 'mobx-easy';

import RootStore from 'bringg-web/stores/root-store';

const externalId = (row: ResponseItem) => getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id)?.external_id;
const priority = (row: ResponseItem) => `${getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id)?.priority ?? ''}`;

const lastWayPointCustomerName = (row: ResponseItem) => {
	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id);
	const { way_points } = task;

	if (way_points) {
		const last = way_points[way_points.length - 1];

		return getRootEnv().dashboardSdk.sdk.v2.customers.get(last.customer_id)?.name;
	}

	return null;
};

const firstWayPointAddressType = (row: ResponseItem) => {
	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id);

	const { way_points } = task;

	return `${way_points?.[0].address_type || ''}`;
};

const lastWayPointAddressType = (row: ResponseItem) => {
	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id);

	const { way_points } = task;

	return `${way_points?.[way_points.length - 1].address_type || ''}`;
};

const tag = (row: ResponseItem) => {
	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id);
	const { tagsStore } = getRoot<RootStore>().data;

	return `${tagsStore.get(task.tag_id)?.tag || ''}`;
};

const servicePlanName = (row: ResponseItem) => {
	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id);
	const { servicePlansStore } = getRoot<RootStore>().data;

	return `${servicePlansStore.servicePlans.get(task.service_plan_id)?.name || ''}`;
};

const rank = (row: ResponseItem) => `${getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id).rank || ''}`;

const groupFollowers = (row: ResponseItem) => {
	const { tasks } = getRootEnv().dashboardSdk.sdk.v2;
	const task = tasks.get(row.id);
	const group = tasks.getGroup(TaskGroupTypes.Followers, task.id);

	return `${group?.length || ''}`;
};

const taskTypeId = (row: ResponseItem) => {
	const typeId = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id).task_type_id;
	return i18next.t(TASK_TYPE_TRANSLATIONS[typeId] || TASK_TYPE_TRANSLATIONS.UNDEFINED);
};

export const cellsProvider = {
	externalId,
	priority,
	lastWayPointCustomerName,
	firstWayPointAddressType,
	lastWayPointAddressType,
	tag,
	servicePlanName,
	rank,
	groupFollowers,
	taskTypeId
};
